import { Call, ApiUrl, ParseGeneralResponse } from './ApiUtils';

export function updateVendorProfile (data, isFreeEmail) {
  const url = ApiUrl('/vendor_profile_db');

  return Call(
    'post',
    url,
    {
      email: data.email,
      first_name: data.firstName,
      id: data.vendorOrgId,
      is_free_email: isFreeEmail,
      job_title: data.jobTitle,
      last_name: data.lastName,
      phone: data.phone
    },
    ParseGeneralResponse,
    {
      responseDataKeys: {
        vendor_profile: 'vendor_profile'
      },
    },
  );
}
